"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var DataQualityStyles_1 = require("../style/DataQualityStyles");
var StyleConstants_1 = require("../style/StyleConstants");
var DataQualityDetailGroup_1 = require("./DataQualityDetailGroup");
function getTooltipAnchorClientRect(el) {
    if (el) {
        var clientRect = el.getBoundingClientRect();
        return {
            left: clientRect.left - StyleConstants_1.DataQualityDetailPanelWidth,
            right: clientRect.right,
            top: clientRect.top,
            bottom: clientRect.bottom,
        };
    }
    return {};
}
function DataQualityDetailPanel(props) {
    var dialogProps = {
        title: props.title || '',
        getAnchorClientRect: function () { return getTooltipAnchorClientRect(props.anchorEl); },
        positioningBehavior: widgets_1.DialogPositioningBehavior.Anchored,
        dialogStyle: DataQualityStyles_1.DataQualityDetailPanelDialogStyle,
        dialogBodyStyle: DataQualityStyles_1.DataQualityDetailPanelDialogBodyStyle,
        anchorOrigin: {
            vertical: widgets_1.VerticalOriginOption.top,
            horizontal: props.side === 'right' ? widgets_1.HorizontalOriginOption.right : widgets_1.HorizontalOriginOption.left
        },
        showFooter: false,
        shouldAdjustPositionOnWindowResize: true,
        testId: 'data-quality-detail-panel',
        isModal: true,
        isGlassTransparent: true,
        type: widgets_1.DialogType.Uber,
        showCloseButton: false,
        handleGlassClick: props.onCloseRequest,
        onCloseRequest: props.onCloseRequest,
        shouldReturnFocusOnClose: false,
        disableAutoFocus: true,
        stackingRootId: props.stackingRootId
    };
    var anchoredWarnings = [];
    var upstreamWarnings = [];
    for (var _i = 0, _a = props.details; _i < _a.length; _i++) {
        var warning = _a[_i];
        if (warning.onContentItem) {
            anchoredWarnings.push(warning);
        }
        else {
            upstreamWarnings.push(warning);
        }
    }
    var renderSpacer = anchoredWarnings.length > 0 && upstreamWarnings.length > 0;
    return (React.createElement(widgets_1.DialogWidget, __assign({}, dialogProps),
        React.createElement(DataQualityDetailGroup_1.DataQualityDetailGroup, { keyPrefix: 'anchored', details: anchoredWarnings, message: Localize_1.Messages.DataQualityContainerAnchored(), linksDisabled: props.linksDisabled || false }),
        renderSpacer && React.createElement(DataQualityStyles_1.DataQualityDetailGroupSpacerDiv, null),
        React.createElement(DataQualityDetailGroup_1.DataQualityDetailGroup, { keyPrefix: 'upstream', details: upstreamWarnings, message: Localize_1.Messages.DataQualityContainerUpstream(), linksDisabled: props.linksDisabled || false })));
}
exports.DataQualityDetailPanel = DataQualityDetailPanel;
//# sourceMappingURL=DataQualityDetailPanel.js.map